import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import {faPersonRunning} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Loader from "../Loader/Loader";
import Routing from "../../services/routing";

const PrivateRoute = () => {
    const { user, loading } = useUser();
    if (loading) {
        return <Loader/>;
    }
    return user ? <Outlet /> : <Navigate to={Routing.routes.login} replace />;
};

export default PrivateRoute;